<template lang="pug">
	section.container-fluid.py-4.animated.fadeIn
		b-row
			b-col(cols="12" md="6" lg="7")
				b-card.mb-4(no-body)
					b-card-header
						h4(style="font-weight:400;") Редактирование профиля
					b-card-body
						Alerts(ref="Alerts")

						b-form(@submit.prevent='onSubmit')
							component(:is="field.widget" v-model="account.data[field.name]" v-for="field in userFormModel" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

							b-button(type='submit' variant='primary' :disabled="account.isFetching")
								b-spinner.mr-2(label="Loading..." small v-if="account.isFetching")
								| Сохранить изменения

			b-col(cols="12" md="6" lg="5")
				change-pass
				change-avatar

</template>
<script type="text/babel">
	import { mapState } from 'vuex'

	import ChangePass from './components/ChangePass.vue'
	import ChangeAvatar from './components/ChangeAvatar.vue'
	import Alerts from '../components/Alerts'

	import userFormModel from './models/form/userSettingsModel';

	import formBackValidationMixin from '@/MIXINS/formBackValidation';
	import collectFormData from '@/MIXINS/collectFormData';
	import formCallbacks from '@/MIXINS/formCallbacks';


	export default {
		name: "profile-settings",
		mixins: [
			formBackValidationMixin,
			collectFormData,
			formCallbacks,
		],
		data: () => ({
			userFormModel,
			msg: {
				ok: 'Изменения сохранены!',
				err: '',
			}
		}),
		components: {
			ChangePass,
			ChangeAvatar,
			Alerts,
		},
		computed: {
			...mapState(['account']),
			error(){ return this.account.error },
		},
		methods: {
			onSubmit() {
				const { username, position, phone, patronymic, organisation, last_name, first_name, email } = this.account.data;
				const data = { username, position, phone, patronymic, organisation, last_name, first_name, email };

				this.$store.dispatch('patchAccount', this.collectFormData(data))
					.then( this.okHandler )
					.catch( this.errHandler );
			},
		},
	}
</script>
<style>
	.custom-file-input ~ .custom-file-label::after {
		content: 'Загрузить'!important;
	}
</style>

